import { localStorage } from 'dibs-browser-storage';

import { FAVORITES_LOCAL_STORAGE_KEYS } from '../constants.ts';

function getFavoritesNudgeDisplayedCount(): number {
    return Number(
        localStorage.getItem(FAVORITES_LOCAL_STORAGE_KEYS.FAVORITES_NUDGE_DISPLAYED_COUNT) ?? 0
    );
}

export { getFavoritesNudgeDisplayedCount };
